"use client";

interface WizardProgressProps {
  currentStep: number;
  labels: string[];
}

export function WizardProgress({ currentStep, labels }: WizardProgressProps) {
  return (
    <div className="flex items-center gap-1">
      {labels.map((label, i) => {
        const stepNum = i + 1;
        const isActive = stepNum === currentStep;
        const isCompleted = stepNum < currentStep;

        return (
          <div key={label} className="flex flex-1 items-center">
            <div className="flex flex-1 flex-col items-center gap-1">
              <div
                className={`flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold transition-colors ${
                  isCompleted
                    ? "bg-blue-600 text-white"
                    : isActive
                      ? "bg-blue-500 text-white ring-2 ring-blue-400/50"
                      : "bg-gray-800 text-gray-500"
                }`}
              >
                {isCompleted ? (
                  <svg
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                ) : (
                  stepNum
                )}
              </div>
              <span
                className={`text-xs ${
                  isActive ? "text-blue-400 font-medium" : "text-gray-500"
                }`}
              >
                {label}
              </span>
            </div>
            {i < labels.length - 1 && (
              <div
                className={`mx-1 h-px flex-1 ${
                  isCompleted ? "bg-blue-600" : "bg-gray-800"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
